import { ChangeType, Entity } from '../../types';

export type ScaleOptions = {
  title?: string;
  formatter?: (value: string | number) => string;
  displayTicks?: boolean;
};

export type DataSet = {
  uniqueId?: string; // unique id field for this data set
  label?: string;
  subLabel?: string;
  changeType?: ChangeType;
  values: {
    raw: number[];
    formatted: string[];
    fillColor: string[];
    textColor: string[];
  };
  changes?: {
    raw: number[];
    formatted: string[];
    textColor: string[];
  };
  stack?: string;
};

export type Data = {
  labels: (string | string[])[];
  sets: DataSet[];
};

export type Legend = {
  display: boolean;
  position: 'top' | 'left';
  clickable?: boolean;
};

export type Tooltip = {
  valueFormatter?: (value: number) => string;
};

export type YColumnSelection = {
  options: Entity[];
  onChange: (name: string) => void;
  value: string;
};

export type FloatingLabelConfig = {
  topLabel: { value: string; textColor: string; bold?: boolean }[];
  bottomLabel?: { value: string; textColor: string; bold?: boolean }[];
};

export type DecompositionChartData = {
  xLabel: string;
  floatingLabel: FloatingLabelConfig;
  data: [number, number];
  fillColor: string;
};
export enum LabelPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
}
